import { IVisibleByPlan } from "./billing";
import { IQuerySettings } from "./others";

/**
 * Type of Dashboard
 */
export enum DASHBOARD_TYPE {
  MOBILE = "MOBILE",
  ON_LIST_ITEM = "ON_LIST_ITEM",
  /**
   * @deprecated This field will be deprecated on the next release, will be replaced by ON_LIST_ITEM
   */
  MOBILE_ON_LIST = "MOBILE_ON_LIST",
  MOBILE_ON_ACTIVITY = "MOBILE_ON_ACTIVITY",
  WEB = "WEB",
  MOBILE_AND_WEB = "MOBILE_AND_WEB",
}

/**
 * Dashboard scope
 */
export enum DASHBOARD_SCOPE {
  GLOBAL = "GLOBAL",
  TEAM = "TEAM",
}

/**
 * Type of KPI
 */
export enum KPI_TYPE {
  LINE_CHART = "LINE_CHART",
  SCORECARD = "SCORECARD",
  GAUGE = "GAUGE",
  PIE_CHART = "PIE_CHART",
  BAR_CHART = "BAR_CHART",
  BAR_CHART_HORIZONTAL = "BAR_CHART_HORIZONTAL",
  STACKED_BAR_CHART = "STACKED_BAR_CHART",
  GROUPED_BAR_CHART = "GROUPED_BAR_CHART",
  MULTIPLE_LINE_CHART = "MULTIPLE_LINE_CHART",
  HEATMAP_CHART = "HEATMAP_CHART",
  CALENDAR_CHART = "CALENDAR_CHART",
  SCATTER_PLOT_CHART = "SCATTER_PLOT_CHART",
  MAP = "MAP",
  TABLE = "TABLE",
  MATRIX = "MATRIX",
  CAROUSEL = "CAROUSEL",
  TIMELINE = "TIMELINE",
  HISTOGRAM = "HISTOGRAM",
  CUSTOMERS_MAP = "CUSTOMERS_MAP",
}
/**
 * Type of the axis
 */
export enum AXIS_TYPE {
  TEXT = "TEXT",
  TIME = "TIME",
  NUMBER = "NUMBER",
}

/**
 * Aggregator operation
 */
export enum AGGREGATOR {
  SUM = "SUM",
  MEAN = "MEAN",
  MIN = "MIN",
  MAX = "MAX",
  NONE = "NONE",
  BOOLEAN = "BOOLEAN",
  PERCENTAGE = "PERCENTAGE",
  COUNT = "COUNT",
  COUNT_DISTINCT = "COUNT_DISTINCT",
}
export enum LEGEND_DISPLAY_POSITION {
  AS_ARC_ON_CHART = "as-arc-on-chart",
  TOP_LEFT = "top-left",
  LEFT = "left",
  BOTTOM_LEFT = "bottom-left",
  TOP_RIGHT = "top-right",
  RIGHT = "right",
  BOTTOM_RIGHT = "bottom-right",
  BOTTOM = "bottom",
}

export enum AGGREGATOR_DIMENSION {
  COLUMN = "COLUMN",
  ROW = "ROW",
}

/**
 * Type of the subquery (for TABLE type) => not used yet
 */
export enum QUERY_TYPE {
  NUMERIC = "NUMERIC",
  TEXT = "TEXT",
  PERCENTAGE = "PERCENTAGE",
}

export enum PIVOT_TYPE {
  MOBILE_USER = "MOBILE_USER",
  TEAM = "TEAM",
  DATE = "DATE",
  CUSTOM = "CUSTOM",
  NONE = "NONE",
}
export enum HEATMAP_COLOR_TYPE {
  sequential = "sequential",
  diverging = "diverging",
  quantize = "quantize",
}

export enum BUSINESS_TYPE {
  STATEMENT = "STATEMENT",
  ROUTE_MGT_LOADING_GUIDE = "ROUTE_MGT_LOADING_GUIDE",
  ACTIVITY_GUIDE = "ACTIVITY_GUIDE",
}

export interface IMatrixChartData {
  data: {
    column?: string;
    row?: string;
    data: { [attrname: string]: string }[];
  }[];
  row_possibilities?: {
    [attrname: string]: string;
    value: string;
    label: string;
  }[];
  column_possibilities?: {
    [attrname: string]: string;
    value: string;
    label: string;
  }[];
}

export interface ISubQuery extends IQuerySettings {
  label: string;
  query: string;
  type?: QUERY_TYPE;
}
export enum HEATMAP_COLOR_PALETTE {
  "default" = "default",
  "brown_blueGreen" = "brown_blueGreen",
  "purpleRed_green" = "purpleRed_green",
  "pink_yellowGreen" = "pink_yellowGreen",
  "purple_orange" = "purple_orange",
  "red_blue" = "red_blue",
  "red_grey" = "red_grey",
  "red_yellow_blue" = "red_yellow_blue",
  "red_yellow_green" = "red_yellow_green",
  "spectral" = "spectral",
  "blues" = "blues",
  "greens" = "greens",
  "greys" = "greys",
  "oranges" = "oranges",
  "purples" = "purples",
  "reds" = "reds",
  "turbo" = "turbo",
  "viridis" = "viridis",
  "inferno" = "inferno",
  "magma" = "magma",
  "plasma" = "plasma",
  "cividis" = "cividis",
  "warm" = "warm",
  "cool" = "cool",
  "cubehelixDefault" = "cubehelixDefault",
  "blue_green" = "blue_green",
  "blue_purple" = "blue_purple",
  "green_blue" = "green_blue",
  "orange_red" = "orange_red",
  "purple_blue_green" = "purple_blue_green",
  "purple_blue" = "purple_blue",
  "purple_red" = "purple_red",
  "red_purple" = "red_purple",
  "yellow_green_blue" = "yellow_green_blue",
  "yellow_green" = "yellow_green",
  "yellow_orange_brown" = "yellow_orange_brown",
  "yellow_orange_red" = "yellow_orange_red",
  "rainbow" = "rainbow",
  "sinebow" = "sinebow",
}

export interface IKPI extends IQuerySettings {
  id?: string; // outdated. Should be deleted in end of August approximatively
  tag: string;
  title: string;
  description: string;
  type: KPI_TYPE;
  query?: string;
  display_summary_number?: boolean;
  data?: any;
  variationData?: any;
  unit?: string;
  is_percentage?: boolean;
  grouped_mode?: boolean;
  target?: number;
  max_value?: number;
  min_value?: number;
  number_of_bins?: number;
  index: number;
  x_axis_type?: AXIS_TYPE;
  aggregator?: AGGREGATOR;
  aggregator_dimension?: AGGREGATOR_DIMENSION;
  row_query?: string;
  row_pivot?: string;
  column_pivot?: string;
  row_pivot_type?: PIVOT_TYPE;
  column_pivot_type?: PIVOT_TYPE;
  sub_queries?: ISubQuery[];
  is_filled?: boolean;
  full_width?: boolean;
  display_total_row?: boolean;
  display_variation?: boolean;
  picture_legend?: string;
  scorecard_label?: string;
  heatmap_color?: HEATMAP_COLOR_PALETTE;
  legend_position?: LEGEND_DISPLAY_POSITION;
  legend_column_name?: string;
  display_y_axis?: boolean;
  display_x_axis?: boolean;
  value_format?: {
    enabled: boolean;
    format: string;
  };
  x_axis_title?: string;
  y_axis_title?: string;
  min_gradient_scale?: number;
  max_gradient_scale?: number;
  is_cumulative?: boolean;
  is_normalized?: boolean;
  display_density?: boolean;
  from_template?: boolean;
  deprecated?: number;
  legend?: TKpiMapLegend;
}
export interface ISupersetDashboard {
  id: number;
  dashboard_title: string;
  owners: Array<{ id: number; first_name: string; last_name: string }>;
  roles: Array<{ id: number; name: string }>;
  published: boolean;
  slug: string;
  url: string;
  tags: string[];
  created_by: { id: number; first_name: string; last_name: string };
}
export interface IDashboard extends IVisibleByPlan {
  id: string;
  name?: string;
  title: string;
  alias_mapping?: { label: string; alias: string }[];
  scope?: DASHBOARD_SCOPE;
  description: string;
  active?: boolean;
  type?: DASHBOARD_TYPE;
  db_type?: DB_TYPE;
  provider?: DASHBOARD_PROVIDER;
  superset_dashboard_id?: string;
  superset_dashboard_uuid?: string;
  superset_dashboard_guest_token?: string;
  kpis: IKPI[];
  created_at: Date;
  updated_at: Date;
  created_by?: string;
  updated_by?: string;
  group_id?: string;
  report_id?: string;
  activity_id?: string;
  list_id?: string;
  host?: string;
  port?: string;
  db_name?: string;
  user?: string;
  password?: string;
  folder?: string;
  locked?: boolean;
  mobile_user_roles?: string[]; //TODO:  deprecated, to remove
  web_user_roles?: string[]; //TODO:  deprecated, to remove
  is_protected?: boolean;
  is_statement?: boolean; // deprecated, to remove in 3.1
  business_type?: BUSINESS_TYPE;
  date_filter?: string;
  user_filter?: string;
  team_filter?: string;
  table_optimizations?: string[];
  hierarchical_level_linked_to_table_optimization?: string;
  raw_data_query?: string;
  raw_data?: any;
  is_default_dashboard?: boolean;
  is_draft?: boolean;
  version?: number;
  threshold_total_row?: number;
}
export interface IDashboardVersion {
  id: string;
  outdated_dashboards: { [key: string]: any };
}
export interface IOutdatedDashboardTable {
  id: string;
  data: string;
  version: number;
  dashboard_id: string;
  created_at: Date;
  created_by: string;
}
export interface DashboardTable {
  id: string;
  data: string;
  type: DASHBOARD_TYPE;
  active: boolean;
}

export interface UserReportTable {
  id: string;
  user_id: string;
  workflow_id: string;
  completed_at: string;
  submissions_count: number;
  type: DASHBOARD_TYPE;
  active: boolean;
}

export enum DB_TYPE {
  POSTGRES = "POSTGRES",
  MSSQL = "MSSQL",
  OPTIMETRIKS = "OPTIMETRIKS",
  BIGQUERY = "BIGQUERY",
}
export enum DASHBOARD_PROVIDER {
  SUPERSET = "SUPERSET",
  OPTIMETRIKS = "OPTIMETRIKS",
}

export enum DEFAULT_DASHBOARD {
  GPS_TRACKING = "_gps_tracking",
  RECAP_REPORT = "_recap_report",
  FREE_TRIAL_USER = "_free_trial_user",
  MONTHLY_SUBMISSIONS = "_monthly_submissions",
  WEEKLY_SUBMISSIONS = "_weekly_submissions",
  LOG_REPORT = "_log_report",
  LIST_ANALYSIS = "_list_analysis",
  TEAM_ANALYSIS = "_team_analysis",
  MASTER_USER_LIST = "_master_user_list",
  BILLING_REPORT = "_billing_report",
  USAGE = "_usage",
  USAGE_PER_CLIENT = "_usage_per_client",
  FEATURE_DASHBOARD = "_feature_dashboard",
  PILOT_REPORT = "_pilot_report",
  MONTHLY_CLIENT = "_monthly_client",
  PIECHART_DISTRIBUTION_REPORT = "_piechart_distribution_report",
}

export enum TKpiMapLegendType {
  /**
   * @deprecated
   */
  LINEAR = "LINEAR",
  /**
   * @deprecated
   */
  SCALE = "SCALE",
  GRADIENT = "GRADIENT",
  CATEGORIES = "CATEGORIES",
}

type TBaseKpiLegend = {
  label: string;
  tag: string;
  /**
   * @deprecated DO NOT USE, Unused will be removed in the next release
   */
  scale?: TKpiMapLegendScaleType;
};

/**
 * @deprecated Unused will be removed in the next release
 */
export enum TKpiMapLegendScaleType {
  LINEAR = "LINEAR",
}

export type TKpiGradientLegend = {
  min: number;
  max: number;
  values: number[];
  valueFormater?: string;
  type: TKpiMapLegendType.GRADIENT;
};

export type TKpiCategoriesLegendValue = {
  label: string;
  color: string;
};
export type TKpiCategoriesLegend = {
  label: string;
  tag: string;
  values: Array<TKpiCategoriesLegendValue>;
  type: TKpiMapLegendType.CATEGORIES;
};

/**
 * @deprecated Unused will be removed in the next release
 */
export type TKpiLinearScaleLegend = {
  min: number;
  max: number;
  values: number[];
  valueFormater?: string;
  type: TKpiMapLegendType.LINEAR | TKpiMapLegendType.SCALE;
};

export type TKpiMapLegend = TBaseKpiLegend &
  (TKpiGradientLegend | TKpiCategoriesLegend | TKpiLinearScaleLegend);

export interface ICustomersMapKpiData {
  _id: string;
  _location__lat: number;
  _location__lng: number;
  [key: string]: any;
}










